import type { ReactNode } from 'react';

export const symbol_format_text_wrap: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M168.5-169.63Q160-178.25 160-191v-579q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v579q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Zm580 0Q740-178.25 740-191v-579q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v579q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM363-284l-86-85q-9-9-9-21t9-21l86-85q9-8 21.1-8.5 12.1-.5 20.9 8.5 9 9 9 21t-9 21l-34 34h179q42 0 71-29t29-71q0-42-29-71t-71-29H280q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h270q66 0 113 47t47 113q0 66-47 113t-113 47H371l34 34q9 9 9 21.16t-8.61 21Q396-275 383.9-275q-12.1 0-20.9-9Z"
		/>
	</svg>
);
